import { Box } from '@forgeglobal/design-framework'
import { TradeIntentType } from 'graphql/bindings/AdminBindings'
import React from 'react'

import { OpportunitiesTable } from './OpportunitiesTable'

interface OpportunitiesTablesProps {
  displayedTables: string[]
  tableVariant: 'issuer' | 'account' | 'dashboard'
  owners?: number[]
  companyId?: number
}

export const OpportunitiesTables: React.FC<OpportunitiesTablesProps> = ({
  displayedTables,
  owners,
  companyId,
  tableVariant,
}) => {
  return (
    <Box mt={2}>
      {displayedTables.map(tableType => {
        return (
          <Box mb={3} key={tableType}>
            <OpportunitiesTable
              opportunityType={tableType === 'bids' ? TradeIntentType.Bid : TradeIntentType.Ask}
              header={`Active ${tableType === 'bids' ? 'Bids' : 'Asks'}`}
              owners={owners}
              companyId={companyId}
              tableVariant={tableVariant}
            />
          </Box>
        )
      })}
    </Box>
  )
}
